import { AccountingDashboardRecentJournalRow } from '@/renderer/types/accounting';
import React from 'react';
import {
  buildActivitySummaries,
  formatCompactCurrency,
  formatJournalTimestamp,
} from './accountingDashboard';

interface AccountingActivityFeedProps {
  entries: AccountingDashboardRecentJournalRow[];
}

export function AccountingActivityFeed({
  entries,
}: AccountingActivityFeedProps) {
  const summaries = buildActivitySummaries(entries);

  return (
    <div className="rounded-[24px] border border-gray-200 bg-white p-4 shadow-sm">
      <div>
        <h3 className="text-lg font-semibold text-slate-950">
          Recent activity summary
        </h3>
        <p className="mt-1 text-sm text-slate-500">
          Grouped activity so you can spot what moved without reading raw
          journals line by line.
        </p>
      </div>

      <div className="mt-4 space-y-3">
        {!summaries.length ? (
          <div className="rounded-[24px] border border-dashed border-slate-200 bg-slate-50 px-4 py-6 text-sm text-slate-500">
            No journal activity was recorded in this period.
          </div>
        ) : (
          summaries.map((item) => (
            <div
              key={item.sourceLabel}
              className="rounded-[22px] border border-gray-200 px-4 py-3"
            >
              <div className="flex items-center justify-between gap-3">
                <div>
                  <p className="text-sm font-semibold text-slate-950">
                    {item.sourceLabel}
                  </p>
                  <p className="mt-1 text-xs text-slate-500">
                    Processed {item.entryCount.toLocaleString()} journal entr
                    {item.entryCount === 1 ? 'y' : 'ies'} · Last update{' '}
                    {formatJournalTimestamp(item.latestTimestamp)}
                  </p>
                </div>
                <div className="text-right">
                  <p className="text-sm font-semibold text-slate-950">
                    {formatCompactCurrency(item.totalAmount)}
                  </p>
                  <p className="mt-1 text-xs text-slate-500">recognized</p>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
